export default __webpack_public_path__ + "static/media/MminisCat.246966ab.png";